export class Consumer {
    public id: number = 0;
    public name?: string;
    public selected: boolean = false;
    public disabled: boolean = false;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    get value(): number {
        return this.id;
    }

    get text(): string | undefined {
        return this.name;
    }

    public clone(): Consumer {
        const consumer: Consumer = new Consumer();

        consumer.id = this.id;
        consumer.name = this.name;
        consumer.selected = this.selected;
        consumer.disabled = this.disabled;

        return consumer;
    }
}
